import React from 'react';

const GaelicFootball = ({ className }) => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width='14'
            height='14'
            viewBox='0 0 14 14'
            className={className}
        >
            <g
                id='Gaelic_Football'
                data-name='Gaelic Football'
                transform='translate(-53.089 -255.071)'
            >
                <path
                    id='Path_3076'
                    data-name='Path 3076'
                    d='M60.17,262.678a29.938,29.938,0,0,1-5.146-.587c-.37-.079-.49-.229-.495-.617-.012-.965-.012-.965.834-1.129a23.843,23.843,0,0,1,4.514-.44,22.83,22.83,0,0,1,4.874.53c.322.071.367.231.388.553.063.967.066,1.025-.866,1.17-.955.149-1.918.261-2.879.375Z'
                    transform='translate(0.24 0.805)'
                />
                <path
                    id='Path_3077'
                    data-name='Path 3077'
                    d='M56.321,264.634a.619.619,0,0,1-.4-.127,4.862,4.862,0,0,1-1.205-2.13,25.3,25.3,0,0,0,5.09.528,24.859,24.859,0,0,0,5.093-.535,4.786,4.786,0,0,1-1.261,2.2c-.016.016-.087.069-.328.07l-3.555.006Q58.039,264.641,56.321,264.634Z'
                    transform='translate(0.271 1.216)'
                />
                <path
                    id='Path_3078'
                    data-name='Path 3078'
                    d='M64.834,260.046a24.847,24.847,0,0,0-5.02-.518,25.773,25.773,0,0,0-5.068.516,4.838,4.838,0,0,1,1.241-2.092.574.574,0,0,1,.366-.1l3.381-.006q1.753,0,3.508.006a.689.689,0,0,1,.383.1A4.624,4.624,0,0,1,64.834,260.046Z'
                    transform='translate(0.276 0.463)'
                />
                <path
                    id='Path_3079'
                    data-name='Path 3079'
                    d='M62.435,267.388a4.367,4.367,0,0,1,.8-1.71,5.894,5.894,0,0,0-.018-7.564,4.07,4.07,0,0,1-.89-2.044A6.836,6.836,0,0,1,65.553,262a6.956,6.956,0,0,1-3.251,5.821C62.349,267.674,62.392,267.531,62.435,267.388Z'
                    transform='translate(1.535 0.166)'
                />
                <path
                    id='Path_3080'
                    data-name='Path 3080'
                    d='M56.269,267.778a6.954,6.954,0,0,1-.028-11.664c-.026.1-.051.2-.075.3a3.644,3.644,0,0,1-.735,1.689A5.836,5.836,0,0,0,55.4,265.7a4.064,4.064,0,0,1,.807,1.844Z'
                    transform='translate(0 0.174)'
                />
                <path
                    id='Path_3081'
                    data-name='Path 3081'
                    d='M59.743,267.43q-.824,0-1.648-.022a.211.211,0,0,1-.155-.051.265.265,0,0,1-.007-.2c.078-.317.148-.636.217-.953.078-.36.156-.72.246-1.077a.345.345,0,0,1,.2-.181c.237-.014.472-.017.71-.017l.74,0,.5,2.158a.356.356,0,0,1-.012.28.222.222,0,0,1-.178.06Z'
                    transform='translate(0.804 1.642)'
                />
                <path
                    id='Path_3082'
                    data-name='Path 3082'
                    d='M58.419,257.584l-.5-2.345a5.007,5.007,0,0,1,1.315-.168,8.039,8.039,0,0,1,1.328.125l-.082.387c-.138.656-.272,1.293-.418,1.927a.3.3,0,0,1-.143.065c-.261.008-.523.009-.786.009Z'
                    transform='translate(0.805 0)'
                />
                <path
                    id='Path_3083'
                    data-name='Path 3083'
                    d='M60.372,264.952h1.907c-.04.154-.076.307-.111.457a5.755,5.755,0,0,1-.4,1.269,1.435,1.435,0,0,1-.6.461c-.1.055-.2.113-.308.176Z'
                    transform='translate(1.213 1.646)'
                />
                <path
                    id='Path_3084'
                    data-name='Path 3084'
                    d='M60.391,257.52l.46-2.18c.618.107,1.015.327,1.091,1a4.817,4.817,0,0,0,.216.888c.029.1.061.194.09.3Z'
                    transform='translate(1.217 0.045)'
                />
                <path
                    id='Path_3085'
                    data-name='Path 3085'
                    d='M57.324,267.127c-.491-.089-.728-.308-.792-.733a8.421,8.421,0,0,0-.264-1.085c-.035-.118-.07-.237-.1-.359h1.829l-.083.407c-.113.562-.223,1.108-.356,1.65a.394.394,0,0,1-.227.121Z'
                    transform='translate(0.512 1.646)'
                />
                <path
                    id='Path_3086'
                    data-name='Path 3086'
                    d='M56.181,257.527c.04-.153.077-.3.113-.454a7.248,7.248,0,0,1,.419-1.343c.058-.127.282-.218.519-.314.086-.035.176-.071.264-.111l.471,2.221Z'
                    transform='translate(0.515 0.039)'
                />
            </g>
        </svg>
    );
};

export default GaelicFootball;
